module.exports = __webpack_public_path__ + "static/media/radio-outside.01a0ded4.svg";